'use client';

import { useRouter } from 'next/navigation';
import { compact, get, map, toString } from 'lodash';
import type { SearchQuestionResponse } from '@/graphql/queries/pages/central-de-ajuda/types';
import { routes } from '@/utils/routes';
import { Select } from '@axa/design-system';
import type { Option } from '@axa/toolkit';

type SearchBarOption = Option & {
  category?: string;
};

export const SearchBar = () => {
  const router = useRouter();

  const onChange = (value?: SearchBarOption) => {
    if (value) {
      router.push(routes.helpCenterAnswer(toString(value.category), toString(value.value)));
    }
  };

  const handleSearchQuestions = async (search?: string): Promise<SearchQuestionResponse> => {
    if (!search?.trim()) {
      return {
        questions: []
      };
    }

    try {
      const response = await fetch(`/api/help-center/search?q=${search.trim()}`, {
        method: 'POST'
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error(error);
      return {
        questions: []
      };
    }
  };

  return (
    <Select
      id="search-help-center"
      placeholder="Digite uma pergunta, assunto ou problema ..."
      leftIcon={{
        name: 'Search'
      }}
      onChange={onChange}
      searchable
      onFilter={async (params) => {
        const data = await handleSearchQuestions(params);

        const searchedValues = compact(
          map(data?.questions, (question) => {
            const category = get(question, 'helpCenterCategories[0].slug');

            if (!category) return null;

            return {
              label: question.question,
              value: question.slug,
              category: get(question, 'helpCenterCategories[0].slug')
            };
          })
        );

        return searchedValues;
      }}
    />
  );
};
